module.exports = "/365FarmNet/dist/stockyardMask.aa2bffd8feb264f4ad2f0f659fe55b4e.html";